export default [
  { title: "API reference", icon: "ri-file-edit-line", link: "/history-money" },
];
